module.exports = __webpack_public_path__ + "static/media/Step6.8361af03.jpg";